module.exports = __webpack_public_path__ + "img/angle-right-solid.89c40099.svg";